import './css/OverlayTheme.css';
import React from 'react';
import { Modal } from 'semantic-ui-react';
import './css/CryptoMoneyPanel.css';
import './css/PasswordPrompt.css';

function StakeConfirmation(props) {

    const spanish = props.language == 'spanish';
    const confirmation = props.confirmation;

    if (!confirmation) return null;

    return (
        <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }}
            open={!!props.open}
            size="tiny"
            className={'tbp-crypto-modal tbp-password-prompt ' + (props.theme == 'light' ? 'light' : 'dark') + (props.desktop ? ' tbp-desktop-crypto-modal' : '')}
            onClose={confirmation.registrationStatus === 'SAVED' ? props.onClose : undefined}
            closeOnEscape={confirmation.registrationStatus === 'SAVED'}
            closeOnDimmerClick={false}
        >
            <h3>{spanish ? 'Aportación Completada' : 'Stake Complete'}</h3>
            <p>{spanish ? 'Tu aportación se ha confirmado.' : 'Your stake has been confirmed.'}</p>
            <p><strong>{spanish ? 'Importe: ' : 'Amount: '}</strong>{confirmation.amount} USD</p>
            <p><strong>{spanish ? 'Red: ' : 'Network: '}</strong>Gnosis</p>
            {confirmation.txHash && (
                <p>
                    <a href={'https://gnosisscan.io/tx/' + encodeURIComponent(confirmation.txHash)} target="_blank" rel="noopener noreferrer">
                        {spanish ? 'Ver Transacción Final' : 'View Final Transaction'}
                    </a>
                </p>
            )}
            {confirmation.registrationStatus === 'SAVING' && (
                <p>{spanish ? 'Guardando la Transacción para Confirmación...' : 'Saving Transaction for Confirmation...'}</p>
            )}
            {confirmation.registrationStatus === 'SAVED' && (
                <p>{spanish ? 'La Transacción está Registrada. El Procesador enviará la Confirmación por Correo.' : 'Transaction Registered. The Processor Will Send Your Email Confirmation.'}</p>
            )}
            {confirmation.registrationStatus === 'FAILED' && (
                <>
                    <p>{spanish ? 'La Aportación se Confirmó en la Red, pero Falta Guardar el Registro. Reintenta Guardar; No Repitas la Aportación.' : 'Your Stake Confirmed on the Network, but Saving the Record Failed. Retry Saving; Do Not Repeat the Stake.'}</p>
                    <button type="button" onClick={props.onRetry}>
                        {spanish ? 'Reintentar Guardar' : 'Retry Saving'}
                    </button>
                </>
            )}
            <button type="button" disabled={confirmation.registrationStatus !== 'SAVED'} onClick={props.onClose}>
                {spanish ? 'Listo' : 'Done'}
            </button>
        </Modal>
    );

}

export default StakeConfirmation;
